import { render } from "./Importi.vue?vue&type=template&id=36475044"
import script from "./Importi.vue?vue&type=script&lang=js"
export * from "./Importi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__